import { ASM_FEATURE, AsmUi, CustomerSearchPage } from '@asm/const';
import { StateUtils } from '@spartacus/core';

export const CUSTOMER_SEARCH_DATA = '[asm] Customer search data';

export interface StateWithAsm {
  [ASM_FEATURE]: AsmState;
}

export interface AsmState {
  customerSearchResult: StateUtils.LoaderState<CustomerSearchPage>;
  asmUi: AsmUi;
}
